<script>
export default {
  functional: true,
  props: {
    duraiton: {
      type: Number,
      default: 100,
    },
    easing: {
      type: String,
      default: 'ease-out',
    },
  },
  render(h, { data, children, props, parent }) {
    const child = children[0];
    const generateTransitionComponent = children =>
      h(
        'transition',
        {
          on: {
            beforeEnter(el) {
              el.style.height = '0';
            },
            enter(el) {
              el.style.height = `${el.scrollHeight}px`;
            },
            beforeLeave(el) {
              el.style.height = `${el.scrollHeight}px`;
            },
            leave(el) {
              // To avoid failure of first collapse.
              if (el.scrollHeight !== 0) {
                el.style.height = '0';
              }
            },
          },
        },
        children
      );
    const wrapperData = {
      ...data,
      style: {
        ...data.style,
        overflow: 'hidden',
        transition: `height ${props.easing} ${props.duraiton}ms`,
      },
      attrs: parent.$options._scopeId
        ? {
            [parent.$options._scopeId]: '',
          }
        : {},
    };

    const isEmpty = !child.children;
    const vShowDirective =
      child.data && child.data.directives && child.data.directives.find(directive => directive.name === 'show');
    const isHidden = vShowDirective && !vShowDirective.value;

    if (isEmpty) {
      // v-if="false"
      return generateTransitionComponent([]);
    }

    if (isHidden) {
      // v-show="false"
      child.data.directives = [...child.data.directives.filter(directive => directive.name !== 'show')];

      return generateTransitionComponent([
        h(
          'div',
          {
            directives: [
              {
                name: 'show',
                value: false,
              },
            ],
            ...wrapperData,
          },
          [child]
        ),
      ]);
    }

    if (vShowDirective && !isHidden) {
      // v-show="true"
      return generateTransitionComponent([
        h(
          'div',
          {
            directives: [
              {
                name: 'show',
                value: true,
              },
            ],
            ...wrapperData,
          },
          [child]
        ),
      ]);
    }

    // v-if="true"
    return generateTransitionComponent([h('div', wrapperData, [child])]);
  },
};
</script>
